const endpoints = {
  getHighlightArticle: "article/highlight",
  getGalleryArticle: "article/gallery",
  getDetailArticle: "article/detail",
  getScheduleMatch: "match/schedule",
  getGroupMatch: "match/group",
  getKnockoutMatch: "match/knock-out",
  getWhatsNew: "article/latest",
  getVenue: "venue",
  getEvent: "event",
  getEventDetail: "event/detail",
  getJourney: "event/journey",
  getEventSeries: "event/series",
  getRegionEventSeries: "event/region/series",
  getEventSeriesDetail: (slug) => `event/series/${slug}`,
  getSection: "section",
  getHallOfFame: (slug) => `event/hall-of-fame/${slug}`,
  getTimeline: (slug) => `timeline/${slug}`,
  postRegister: "/auth/register",
  postUpdateRegister: "event/registration-data/update",
  getCurrentRegistration: "event/registration-data",
  login: "/auth/authenticate",
  postAddPlayer: (eventRegistrationId) => `/event/add-players/${eventRegistrationId}`,
  paymentDetail: () => `/payment/details`,
  postProofPayment: (event_registration_id) => `/payment/update/${event_registration_id}`,
  postUpdatePaymentExpired: (eventRegistrationId) =>
    `/payment/update-expired/${eventRegistrationId}`,
  getMainRegionGallery: "event/gallery/main-region",
  getRegionGallery: "event/gallery/series",
  getYearsGallery: "event/gallery/years",
  getTokenLiveScore: "lapangbola/authenticate",
  getCompetitionList: "get_competitions_list",
  getListOfClub: "get_clubs_list",
  getMatches: `lapangbola/matches`,
  getSocAttribute: "soc",
  getMatchesDetail: (id) => `lapangbola/matches/${id}`,
  getLiveMatchesDetail: (id) => `lapangbola/live-match-detail/${id}`,

  getClassmentsDetail: (id) => `lapangbola/classments/${id}`,
  getClassmentsDetailV2: `match/get-match-standing`,
  getKnockoutBracket: "match/get-knockout-bracket",

  getTimelineSoc: "soc/timeline/soc",
  getMainRegionSoc: "soc/main-region",
  getSocChampions: "soc/champions",
  getMatchTopStats: "lapangbola/match-top-stats",
  getCurrentEventSeries: "event/current-series",
  postRegisterDance: "/auth/dance-register",
  postUpdateDanceRegistration: "event/dance-registration-data/update",
  getEventCategory: "/event/category",
  getMatchList: "/match/get-matches",
  getMatchDetail: "/match/get-match-detail",
  getVideos: "/article/video",
  postAddDanceMember: (eventRegistrationId) => `/event/add-dancers/${eventRegistrationId}`,
  postAddDanceMember: (eventRegistrationId) => `/event/add-dancers/${eventRegistrationId}`,
  getActivity: "/article/activity",
  getActivityDetail: `/article/activity/detail`,
};

export default endpoints;
